"use strict";

const getLocalStorage = (key) => {
    try {
        const value = localStorage.getItem(key);

        return JSON.parse(value);
    } catch (error) {
        console.error(`Error getting value from localStorage: ${error}`);
        return null;
    }
};

const setLocalStorage = (key, value) => {
    try {
        const serializedValue = JSON.stringify(value);

        localStorage.setItem(key, serializedValue);
    } catch (error) {
        console.error(`Error setting value in localStorage: ${error}`);
    }
};

const removeLocalStorageKey = (key) => {
    localStorage.removeItem(key);
};

export { getLocalStorage, setLocalStorage, removeLocalStorageKey };
